import styles from './profile.module.scss'

import { memo } from 'react'
import { Navigate } from 'react-router'

import { MenuSelect } from './components/MenuSelect/MenuSelect'
import { MenuWidget } from './components/MenuWidget/MenuWidget'

import { Grid, Layout } from 'antd'
import { PATH_SEGMENT } from 'routes/pathSegments'
import { generateRouter } from 'routes/routes.utils'
import { ChangePassword } from './features/ChangePassword/ChangePassword'
import { Deposit } from './features/Deposit/Deposit'
import { Mailbox } from './features/Mailbox/Mailbox'
import { CreditCards } from './features/Payment/CreditCards'
import { PersonalProfile } from './features/PersonalProfile/PersonalProfile'
import { Preferences } from './features/Preferences/Preferences'

import { useAuth } from 'app/providers/auth/AuthProvider'
import { UserWidget } from './components/UserWidget/UserWidget'
import { BillingHistory } from './features/BillingHistory/BillingHistory'
import CompletedBookings from './features/CompletedBookings/CompletedBookings'
import { MediaPreferences } from './features/MediaPreferences/MediaPreferences'
import { PaymentHistory } from './features/PaymentsHistory/PaymentHistory'
import { Prescriptions } from './features/Prescriptions'
import TransactionHistory from './features/TransactionHistory/TransactionHistory'
import { TransactionsMapping } from './features/TransactionsMapping/TransactionsMapping'

const { Sider, Content } = Layout
const { useBreakpoint } = Grid

export const Profile = memo(() => {
  const breakpoint = useBreakpoint()
  const { isStaff, hasEmrEnabled } = useAuth()

  const routesConfig = {
    ...(!isStaff
      ? {
          [PATH_SEGMENT.CREDIT_CARDS]: <CreditCards />,
          [PATH_SEGMENT.BILLING_HISTORY]: <BillingHistory />,
          [PATH_SEGMENT.MAILBOX_PROFILE]: <Mailbox />,
          [PATH_SEGMENT.DEPOSIT]: <Deposit />,
          [PATH_SEGMENT.PAYMENTS_HISTORY]: <PaymentHistory />,
        }
      : {}),
    [`${PATH_SEGMENT.PRESCRIPTIONS}/*`]: <Prescriptions />,
    [PATH_SEGMENT.TRANSACTIONS_MAPPING]: <TransactionsMapping />,
    [PATH_SEGMENT.TRANSACTIONS_HISTORY]: <TransactionHistory />,
    [PATH_SEGMENT.COMPLETED_BOOKINGS]: <CompletedBookings />,
    [PATH_SEGMENT.PERSONAL_PROFILE]: <PersonalProfile />,
    [PATH_SEGMENT.PREFERENCES]: <Preferences />,
    [PATH_SEGMENT.CHANGE_PASSWORD]: <ChangePassword />,
    [PATH_SEGMENT.MEDIA_PREFERENCES]: <MediaPreferences />,
    [PATH_SEGMENT.OTHER]: <Navigate to={PATH_SEGMENT.PERSONAL_PROFILE} replace />,
  }

  const isTabletOrSmaller = !breakpoint.lg

  return (
    <>
      <div className={styles.header}>
        <UserWidget />
      </div>
      <Layout className={styles.layout}>
        {isTabletOrSmaller ? (
          <div className={styles.mobileSelect}>
            <MenuSelect isStaff={isStaff} hasEmrEnabled={hasEmrEnabled} />
          </div>
        ) : (
          <Sider width={266} className={styles.sider}>
            <MenuWidget isStaff={isStaff} hasEmrEnabled={hasEmrEnabled} />
          </Sider>
        )}
        <Content className={styles.container}>{generateRouter(routesConfig)}</Content>
      </Layout>
    </>
  )
})
